import { render, staticRenderFns } from "./ConfirmPaymentDialog.vue?vue&type=template&id=a89313a8&"
import script from "./ConfirmPaymentDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPaymentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports